import React, { useState, useEffect } from 'react';
import '../css/Table.css';
import left from '../images/left-arrow.png';
import right from '../images/right-arrow.png';
import 'jspdf-autotable';
import CustomAlert from './CustomeAlert';
//import jsPDF from 'jspdf';
//import * as XLSX from 'xlsx';
// Import the custom alert component
//import CustomConfirm from './CustomConfirm'; // Import the custom confirm component

function Table({ district = "all", taluka = "", village = "" }) {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [alertData, setAlertData] = useState({ show: false, message: '' });


  // Fetch data based on 'summ' prop (summary or user data)
  useEffect(() => {
    const fetchData = async (page) => {
      try {
        const url = `https://checkmateelection.com/ramshinde/admin/table.php?page=${page}&page_size=9&district=${district}&taluka=${taluka}&village=${village}`;

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Failed to fetch data from the server');
        }

        const jsonData = await response.json();
        setData(jsonData.result);
        setTotalPages(jsonData.total_page);
      } catch (error) {
        setData([]);
        console.error('Error:', error);
        setAlertData({ show: true, message: 'An error occurred while fetching the data. Please check your network or try again later.' });
      }
    };

    fetchData(currentPage); // ✅ Call function inside useEffect

  }, [currentPage, district, taluka, village]); // ✅ Correct dependencies

  /*useEffect(() => {
    const intervalId = setInterval(() => {
      fetchData(currentPage); // Re-fetch data every 20 seconds
    }, 40000); // 20000 ms = 20 seconds

    // Clean up the interval when the component is unmounted or dependencies change
    return () => clearInterval(intervalId);
  }, [currentPage,  district,taluka,village]);


  // Excel export function
  {/*useEffect(() => {
    if (xls) {
      const columnNames = summ
        ? ['Booth Number', 'Booth Name', 'Voter Name', 'Voter Card', 'Total Vote', 'Total Vote Done', 'Total Vote Done (%)', 'Total Vote NotDone', 'Total Vote NotDone (%)']
        : ['Booth Number', 'Voter Number', 'Voter Name', 'Card Number', 'Voting Status', 'Address'];

      const columnValues = data.map(dat => 
        summ
          ? [
              dat.boothno, 
              dat.boothname, 
              dat.votername, 
              dat.cardno, 
              dat.totalvotes, 
              dat.totalvotedone, 
              dat.totalvotedonepercent, 
              dat.totalvotenotdone, 
              dat.totalvotenotdonepercent
            ]
          : [
              dat.boothno, 
              dat.voterno, 
              dat.votername, 
              dat.cardno, 
              dat.rationcardno === 0 ? 'pending' : 'done', 
              dat.address
            ]
      );

      const wb = XLSX.utils.book_new();
      const datas = [columnNames, ...columnValues];
      const ws = XLSX.utils.aoa_to_sheet(datas);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/octet-stream' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = summ ? 'summary.xlsx' : 'data.xlsx';
      link.click();
    }
  }, [data, xls, summ]);*/

  // Pagination functions
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  return (
    <>
      {/* Display the custom alert */}
      <CustomAlert
        show={alertData.show}
        message={alertData.message}
        onClose={() => setAlertData({ show: false, message: '' })}
      />

      {/* Render the table depending on whether it's summary or user data */}
      {/*
        <div className="container-fluid container-m mt-5">
          <table className="table table-bordered mt-1">
            <thead>
              <tr id="main-row" style={{ border: '1px solid black' }}>
                <th scope="col" colSpan={7}><h6>Summary</h6> </th>
              </tr>
              <tr>
                <th scope="row" id="row-o">Booth No</th>
                <th scope="col" id="row-o">Booth Name</th>
                <th scope="col" id="row-j">Total Vote</th>
                <th scope="col" id="row-j">Total Vote Done</th>
                <th scope="col" id="row-m">Total Vote Done (%)</th>
                <th scope="col" id="row-m">Total Vote NotDone</th>
                <th scope="col" id="row-j">Total Vote NotDone(%)</th>
              </tr>
            </thead>
            <tbody>
              {data.map((dat, key) => (
                <tr key={key + 1}>
                  <td>{dat.boothno}</td>
                  <td>{dat.boothname}</td>
                  <td>{dat.tvoter}</td>
                  <td>{dat.votedone}</td>
                  <td>{dat.pdonevoter} %</td>
                  <td>{dat.notdone}</td>
                  <td>{dat.pnotdonevoter} %</td>
                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
   */}
      <div className="container-fluid container-m mt-5">
        <table className="table table-bordered mt-1">
          <thead>
            <tr id="main-row" style={{ border: '1px solid black' }}>
              <th scope="col" colSpan={13}><h6>User Details</h6> </th>
            </tr>
            <tr >
              <th scope="col " id="row-o">संपूर्ण नाव</th>
              <th scope="col" id="row-o"  className='sp'>संपूर्ण पत्ता</th>
              <th scope="col" colSpan={3} id="row-o">पदाधिकारी किवा संस्था संघटना पदाधिकारी </th>

              <th scope="col" colSpan={3} id="row-o">सरकारी अधिकारी /कर्मचारी </th>

              <th scope="col" colSpan={3} id="row-o">खाजगी व्यावसायिक/खाजगी नोकरदार</th>

              <th scope="col" id="row-o">फोन नंबर </th>
              <th scope="col" id="row-o">मेल आईडी  </th>

            </tr>
            <tr >
              <th id="row-o"></th>
              <th id="row-o"></th>
              <th id="row-o" >पदाधिकारी </th>
              <th id="row-o">संस्था नाव</th>
              <th id="row-o">पत्ता </th>
              <th id="row-o">पदनाम</th>
              <th id="row-o">कार्यालयाचे नाव </th>
              <th id="row-o">पत्ता </th>
              <th id="row-o">पदनाम</th>
              <th id="row-o">फर्मचे नाव </th>
              <th id="row-o">पत्ता </th>
              <th id="row-o"></th>
              <th id="row-o"></th>
            </tr>

          </thead>
          <tbody>
            {(data && data.length > 0) ? (
              data.map((dat, key) => (
                <tr key={key + 1} style={{ fontSize: "15px" ,border:"2px solid black"}}>
                  <td className="col" style={{ fontSize: "15px" ,border:"1px solid black"}}>{dat.fname} {dat.mname} {dat.lname}</td>
                  <td  style={{ wordBreak: "keep-all" }}>{dat.village},{dat.taluka},<br/>{dat.district}</td>
                  <td className="col" >{dat.postname === "नाही"||"" ? "" : dat.postname}</td>
                  <td className="col" >{dat.sanghatnaname === "नाही"||"" ? "" : dat.sanghatnaname}</td>
                  <td className="col" >{dat.sanghatnaaddress === "नाही"||"" ? "" : dat.sanghatnaaddress}</td>
                  <td className="col" >{dat.post === "नाही"||"" ? "" : dat.post}</td>
                  <td className="col" >{dat.govkaryalay === "नाही"||"" ? "" : dat.govkaryalay}</td>
                  <td className="col" ></td>
                  <td className="col" >{dat.businessdetail === "नाही"||"" ? "" : dat.businessdetail}</td>
                  <td className="col" >{dat.businessaddress === "नाही"||"" ? "" : dat.businessaddress}</td>
                  <td className="col" ></td>
                  <td className="col" >{dat.mobileno === "नाही"||"" ? "" : dat.mobileno}</td>
                  <td className="col" style={{ wordBreak: "break-word" }}>{dat.emailid === "नाही"||"" ? "" : dat.emailid}</td>


                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" style={{ textAlign: 'center' }}>Record not found</td>
              </tr>
            )}
          </tbody>


        </table>
      </div>


      <div className="pagination mb-2 mt-1">
        <img
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          src={left}
          alt="previous"
          style={{ background: 'white', borderRadius: '50px', marginRight: '10px' }}
        />
        <span style={{ color: 'white' }}>
          {currentPage} of {totalPages}
        </span>
        <img
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          src={right}
          alt="next"
          style={{ background: 'white', borderRadius: '50px', marginLeft: '10px' }}
        />
      </div>
    </>
  );
}

export default Table;
